import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultMediaEvents = {
    onSettingsChange: noop
};

function useMediaEvents(props) {
    const {
        mediaEvents: propsMediaEvents
    } = props;

    const {
        events: mediaEvents
    } = useEvents(defaultMediaEvents, propsMediaEvents);

    const result = {
        mediaEvents
    };

    useDebugValue(result);

    return result;
}

export {useMediaEvents};
